export default {
  applyToVersions: "<2.6.0",
  type: "before",
  name: "move 'none' relations to relations with updateType 'none'",
  migrate(data) {
    if (!data.relations) {
      return data;
    }

    for (const relationId in data.relations.items) {
      const relation = data.relations.items[relationId];
      if (!("none" in relation)) continue;

      if (relation.none) {
        relation.updateType = "none";
      }
      delete relation.none;
    }

    return data;
  }
};
